import moment from 'moment'
import objectPath from 'object-path'
import { getCheckValue, getCurrentUi, isNumber } from '../Data'
import { OPTIONS_CONDITION } from 'designer/component/config/conditions'
import { checkPropTab } from '../Api'
import cloneDeep from 'clone-deep'

export const getCompareValue = (key, name, type, data) => {
  let { datasources = {}, urlParams = {}, formData = {} } = data
  let conditionValue
  if (type === 'response') {
    conditionValue = objectPath.get(formData, `@response.${key}`)
  } else if (type === 'datasources') {
    conditionValue = objectPath.get(datasources, key)
  } else if (type === 'pathParams') {
    conditionValue = objectPath.get(urlParams, key)
  } else if (type === 'queryParams') {
    conditionValue = objectPath.get(urlParams, key)
  } else if (type === 'localStorage') {
    conditionValue = localStorage.getItem(key)
  } else {
    if (objectPath.has(formData, key)) {
      conditionValue = objectPath.get(formData, key)
    } else if (objectPath.has(formData, name)) {
      conditionValue = objectPath.get(formData, name)
    }
  }
  return conditionValue
}

const createCompareValue = (conditionValue, condition, data) => {
  let compare = objectPath.get(condition, 'compare')
  let compareToKey = objectPath.get(condition, 'compareTo.key')
  let compareToName = objectPath.get(condition, 'compareTo.name')
  let compareToTag = objectPath.get(condition, 'compareTo.tag')
  if (compare === 'system') {
    conditionValue = getCompareValue(
      compareToKey,
      compareToName,
      compareToTag,
      data,
    )
  } else if (compare === 'today') {
    conditionValue = moment().format('YYYY-MM-DD HH:mm:ss')
  } else if (
    compare === 'value' &&
    objectPath.has(condition, 'compareTo.value')
  ) {
    conditionValue = objectPath.get(condition, 'compareTo.value')
  }
  return conditionValue
}

const compareTwoValue = (elementValue, conditionValue, condition, data) => {
  let compareToTag = objectPath.get(condition, 'compareTo.tag')
  conditionValue = createCompareValue(conditionValue, condition, data)
  if (compareToTag === 'date') {
    let date1 = moment(elementValue).format('YYYY-MM-DD')
    let date2 = moment(conditionValue).format('YYYY-MM-DD')
    elementValue = new Date(date1).getTime()
    conditionValue = new Date(date2).getTime()
  } else {
    elementValue = getCheckValue(elementValue)
    conditionValue = getCheckValue(conditionValue)
  }
  return { elementValue, conditionValue }
}

const isEqual = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue === compareValue.conditionValue
}

const isCheckLength = (condition, value) => {
  return value?.length === condition?.length
}

const isSelectFavorite = (value, isFavorite) => {
  return isFavorite ? isFilled(value) : false
}

const isNotEqual = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue !== compareValue.conditionValue
}

export const isFilled = (elementValue) => !isEmpty(elementValue)

export const isEmpty = (elementValue) => {
  if (
    elementValue === '' ||
    elementValue === undefined ||
    elementValue === null
  ) {
    return true
  }
  if (Array.isArray(elementValue) && elementValue.length === 0) {
    return true
  }
  if (
    typeof elementValue === 'object' &&
    Object.values(elementValue).length === 0
  ) {
    return true
  }
  return false
}

export const isInclude = (conditionValue, compareValue) => {
  let isFoundSplit = compareValue.search(',')
  if (isFoundSplit) {
    let compareValueList = compareValue.split(',')
    let found = compareValueList.find((value) => {
      return getCheckValue(value) === getCheckValue(conditionValue)
    })
    return found ? true : false
  }
  return false
}

export const isExclude = (conditionValue, compareValue) => {
  return !isInclude(conditionValue, compareValue)
}

const isContained = (conditionValue, elementValue) => {
  let isContained = elementValue
    ? elementValue.includes(conditionValue) ||
      (isNumber(conditionValue) &&
        elementValue.includes(Number(conditionValue)))
    : false
  return isContained
}

const isNotContained = (conditionValue, elementValue) => {
  let isNotContained = elementValue
    ? !elementValue.includes(conditionValue) ||
      (isNumber(conditionValue) &&
        !elementValue.includes(Number(conditionValue)))
    : false
  return isNotContained
}

const isAllOf = (elementValue) => {
  return elementValue
}

const isAnyOf = (elementValue) => {
  return elementValue
}

const isGreater = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue > compareValue.conditionValue
}

const isLess = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue < compareValue.conditionValue
}

const isGreaterOrEqual = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue >= compareValue.conditionValue
}

const isLessOrEqual = (conditionValue, elementValue, condition, data) => {
  let compareValue = compareTwoValue(
    elementValue,
    conditionValue,
    condition,
    data,
  )
  return compareValue.elementValue <= compareValue.conditionValue
}

const isCondition = (value) => {
  return value ? true : false
}

export const getConditionKey = (key) => {
  let keyList = key.split('.')
  if (keyList.length === 1) {
    return { conditionKey: key }
  }
  let conditionKey, conditionState, conditionValue
  let stateIndex = keyList.findIndex((item) =>
    OPTIONS_CONDITION.find(({ value }) => value === item),
  )
  if (stateIndex > -1) {
    let keyPart = keyList.slice(0, stateIndex)
    let valuePart = keyList.slice(stateIndex)
    conditionKey = keyPart.join('.')
    conditionState = valuePart[0]
    conditionValue = valuePart[1]
  }
  return { conditionKey, conditionState, conditionValue }
}

export const checkCondition = (
  designContext,
  { conditionKey, conditionState, conditionValue, conditionName },
  data,
  status,
  condition,
) => {
  let { formData = {}, urlParams = {}, datasources, dataTable, rowData } = data

  let {
    isActive,
    isOnClick,
    isOnChange,
    isAfterSuccess,
    isSelectRow,
    isUnSelectRow,
    isAddRow,
    isEditRow,
    isDeleteRow,
    isWidget,
    isApiTable,
    isDynamic,
    isMainDynamic,
    isInDynamic,
    formComponentName,
    isFavorite,
  } = status

  let { jsonForm, isUiChanged, setIsUiChanged, user, datasourceValue } =
    designContext

  if (!datasources) {
    datasources = objectPath.get(designContext, '@datasource')
  }
  let responseData = data.response || {}
  let conditionLayout = objectPath.get(condition, 'layout')
  let value

  if (formComponentName && conditionLayout !== 'response') {
    let key = condition.valueKey
    if (objectPath.has(formData, `${formComponentName}.${key}`)) {
      value = objectPath.get(formData, `${formComponentName}.${key}`)
    } else if (objectPath.has(formData, conditionName)) {
      value = objectPath.get(formData, conditionName)
    } else if (objectPath.has(formData, key)) {
      value = objectPath.get(formData, key)
    }
  } else if (isMainDynamic) {
    if (condition?.isElement) {
      let { itemData } = data
      if (objectPath.has(itemData, condition.valueKey)) {
        value = objectPath.get(itemData, condition.valueKey)
      } else if (objectPath.has(itemData, condition.key)) {
        value = objectPath.get(itemData, condition.key)
      } else {
        value =
          objectPath.get(formData, condition.valueKey) ||
          objectPath.get(formData, condition.key) ||
          objectPath.get(formData, status.name)
      }
    } else {
      value =
        objectPath.get(formData, condition.valueKey) ||
        objectPath.get(formData, condition.key) ||
        objectPath.get(formData, status.name)
    }
  } else if (isInDynamic) {
    let { dynamicData } = status
    value = objectPath.get(dynamicData, status.name)
  } else if (isDynamic) {
    value =
      objectPath.get(formData, condition.valueKey) ||
      objectPath.get(formData, condition.key) ||
      objectPath.get(formData, status.name)
  } else if (condition.isTabParam) {
    let containerKey = condition.tabKey
    let paramName = condition.name
    conditionValue = createCompareValue(conditionValue, condition, data)
    value = checkPropTab({ designContext }, { containerKey, paramName })
  } else if (conditionLayout === 'urlParam') {
    value = objectPath.get(urlParams, conditionKey)
  } else if (conditionLayout === 'localStorage') {
    value = localStorage.getItem(conditionKey)
  } else if (conditionLayout === 'condition') {
    let conditionName = objectPath.get(condition, 'name')
    let conditionKey = objectPath.get(condition, 'key')
    let conditionValue

    if (objectPath.has(formData, `@condition.${conditionName}`)) {
      conditionValue = objectPath.get(formData, `@condition.${conditionName}`)
    } else {
      conditionValue = objectPath.get(formData, `@condition.${conditionKey}`)
    }
    value = conditionValue
  } else if (conditionLayout === 'datasources') {
    let conditionKey = objectPath.get(condition, 'valueKey')
    value =
      objectPath.get(responseData, conditionKey) ||
      objectPath.get(datasources, conditionKey) ||
      objectPath.get(datasourceValue, conditionKey)
  } else if (conditionLayout === 'response') {
    let conditionKey = objectPath.get(condition, 'valueKey')
    value =
      objectPath.get(responseData, conditionKey) ||
      objectPath.get(formData, `@response.${conditionKey}`)
  } else if (conditionLayout === 'user') {
    conditionValue = createCompareValue(conditionValue, condition, data)
    value = objectPath.get(user, condition.key)
  } else if (conditionLayout === 'perspective') {
    value = objectPath.get(urlParams, 0)
  } else {
    if (isWidget) {
      value =
        objectPath.get(formData, condition.key) ||
        objectPath.get(formData, condition.valueKey)
    } else {
      value = objectPath.get(formData, conditionKey)
    }
  }

  if (conditionValue === undefined && condition) {
    conditionValue = condition?.value
  } else if (conditionValue === 'true') {
    conditionValue = true
  } else if (conditionValue === 'false') {
    conditionValue = false
  }

  switch (conditionState) {
    case 'isEqual':
      conditionValue = isNumber(conditionValue)
        ? Number(conditionValue)
        : conditionValue
      value = isNumber(value) ? Number(value) : value
      return isEqual(conditionValue, value, condition, data)
    case 'isNotEqual':
      conditionValue = isNumber(conditionValue)
        ? Number(conditionValue)
        : conditionValue
      value = isNumber(value) ? Number(value) : value
      return isNotEqual(conditionValue, value, condition, data)
    case 'isFilled':
      return isFilled(value)
    case 'isEmpty':
      return isEmpty(value)
    case 'isCheckLength':
      return isCheckLength(condition, value)
    case 'isSelectFavorite':
      return isSelectFavorite(value, isFavorite)
    case 'isContained':
      return isContained(conditionValue, value)
    case 'isNotContained':
      return isNotContained(conditionValue, value)
    case 'isAllOf':
      value = objectPath.get(formData, conditionValue)
      return isAllOf(value)
    case 'isAnyOf':
      value = objectPath.get(formData, conditionValue)
      return isAnyOf(value)
    case 'isGreater':
      return isGreater(Number(conditionValue), Number(value), condition, data)
    case 'isLess':
      return isLess(Number(conditionValue), Number(value), condition, data)
    case 'isGreaterOrEqual':
      return isGreaterOrEqual(
        Number(conditionValue),
        Number(value),
        condition,
        data,
      )
    case 'isLessOrEqual':
      return isLessOrEqual(
        Number(conditionValue),
        Number(value),
        condition,
        data,
      )
    case 'isShow':
      return true
    case 'isHide':
      return true
    case 'isEnable':
      return true
    case 'isDisable':
      return true
    case 'isOnClick':
      return isOnClick ? true : false
    case 'isOnChange':
      return isOnChange ? true : false
    case 'isAfterSuccess':
      return isAfterSuccess ? true : false
    case 'isActive':
      return isActive
    case 'isActiveTab':
      let tabFullKey = jsonForm.schema.mapKey[conditionKey] || ''
      let tabKeyList = cloneDeep(tabFullKey.split('.')) || []
      let tabPanelKey = tabKeyList.pop()
      let tabKey = tabKeyList.pop()
      let activeTab = tabKey
        ? objectPath.get(isUiChanged, ['activeTab', tabKey])
        : ''
      let statusActiveTab = status?.isActiveTab
      let tabPanelUi = getCurrentUi(
        conditionKey,
        jsonForm.schema,
        jsonForm.uischema,
        isUiChanged,
      )
      let statusTabPanelUi = statusActiveTab
        ? getCurrentUi(
            statusActiveTab,
            jsonForm.schema,
            jsonForm.uischema,
            isUiChanged,
          )
        : null
      return (
        activeTab === conditionKey ||
        activeTab === tabPanelKey ||
        activeTab === tabPanelUi?.key ||
        activeTab === tabPanelUi?.name ||
        statusActiveTab === conditionKey ||
        statusActiveTab === tabPanelKey ||
        statusActiveTab === tabPanelUi?.key ||
        statusActiveTab === tabPanelUi?.name ||
        statusTabPanelUi?.key === conditionKey ||
        statusTabPanelUi?.name === conditionKey
      )
    case 'isCondition':
      return isCondition(value)
    case 'isCompareOption':
      return true
    case 'isSelectRow':
      return isSelectRow
    case 'isUnSelectRow':
      return isUnSelectRow
    case 'isAddRow':
      if (isAddRow) {
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: true,
          key: conditionKey,
          table: dataTable,
          rowData,
          isApiTable,
          isAddRow,
        })
        setIsUiChanged(isUiChanged)
      }
      return isAddRow
    case 'isEditRow':
      if (isEditRow) {
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: true,
          key: conditionKey,
          table: dataTable,
          rowData,
          isApiTable,
          isEditRow,
        })
        setIsUiChanged(isUiChanged)
      }
      return isEditRow
    case 'isAfterAddRow':
      if (isAddRow) {
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: false,
          isApiTable,
          isAddRow,
        })
      }
      return isAddRow
    case 'isAfterEditRow':
      if (isEditRow) {
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: false,
          isApiTable,
          isEditRow,
        })
      }
      return isEditRow
    case 'isAfterDeleteRow':
      if (isDeleteRow) {
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: false,
          isApiTable,
          isDeleteRow,
        })
      }
      return isDeleteRow
    default:
      return undefined
  }
}
